/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
import { ref, Ref } from 'vue';
import {
  useTableColumn,
  BaseButton,
  createDialog,
  XrkTableRef,
  useCreateModal,
  XrkMessage,
  BaseIcon,
  BaseToolTip
} from 'xrk-components';
import BaseInsert from '../components/base-insert.vue';
import TaskUploadFile from '../components/task-upload-file.vue';
import { formatter, translator } from '@/utils';
import {
  AUDIT_STATUS,
  PLATFORM_AUDIT_STATUS,
  IS_OVERDUE,
  SETTLEMENT_STATUS,
  HETONG_STATUS,
  IN_STATUS,
  PROJECT_STATUS,
  CANCEL_STATUS,
  REALNAME_STATUS,
  CHECK_STATUS,
  OPEN_STATUS,
  USER_TYPE
} from '../constants';

import { ProjectType } from '../types';
import { updatePrice } from '../data-source/apis';
import { useProjectDetailStore } from '@/views/project-center-edit/src/store';
import { IS_ASSISTANT } from '@/config';
import {
  InfoFilled,
  WarningFilled,
  WarnTriangleFilled
} from '@element-plus/icons-vue';
import router from '@/router';

/** 序号 */
export const indexCol = useTableColumn({
  type: 'index',
  label: '序号'
});

/** 终端服务人员 */
export const servicePersonCol = useTableColumn({
  label: '终端服务人员',
  prop: 'username'
});

/** 个体名称 */
export const individualNameCol = useTableColumn({
  label: '个体工商户名称',
  prop: 'individualName'
});

/** 所属园区 */
export const parkNameCol = useTableColumn({
  label: '所属园区',
  prop: 'businessParkName'
});

/** 手机号 */
export const phoneCol = useTableColumn({
  label: '手机号',
  prop: 'phone',
  formatter: ({ cellValue }) =>
    cellValue === null ? '-' : formatter.maskPhone(cellValue)
});

/** 人员标签 */
export const userTagCol = useTableColumn({
  label: '人员标签',
  prop: 'userTag',
  formatter: ({ cellValue }) => cellValue || '未设置'
});

/** 提交时间 */
export const submitDtCol = useTableColumn({
  label: '提交时间',
  prop: 'editStatusAt',
  formatter: ({ cellValue }) => formatter.date(cellValue),
  width: 200,
  sortable: 'custom',
  sortOrders: ['ascending', 'descending', null]
});

/** 拜访时间 */
export const visitDtCol = useTableColumn({
  label: '拜访时间',
  prop: 'visitAt',
  formatter: ({ row }) => {
    return (
      formatter.date(row.visitStartAt) + '-' + formatter.date(row.visitEndAt)
    );
  },
  width: 300,
  sortable: 'custom',
  sortOrders: ['ascending', 'descending', null]
});

/** 数字拜访 拜访时间 */
export const visitDtByDigitCol = useTableColumn({
  label: '拜访时间',
  prop: 'visitAt',
  formatter: ({ cellValue }) => {
    return formatter.date(cellValue);
  },
  sortable: 'custom',
  width: 200,
  sortOrders: ['ascending', 'descending', null]
});

/** 任务编码 */
export const taskCodeCol = useTableColumn({
  label: '任务编码',
  prop: 'taskCode'
});

/** 审核人 */
export const auditUserCol = useTableColumn({
  label: '服务商审核人',
  prop: 'auditUser'
});

/** 职业认证 */
export const occupationAuthStatusCol = useTableColumn({
  label: '职业认证',
  prop: 'occupationAuthStatus'
});

/** 实名状态 */
export const realNameStatusCol = useTableColumn({
  label: '实名状态',
  prop: 'realNameStatus',
  formatter: ({ cellValue }) => REALNAME_STATUS[cellValue]?.label || '-'
});

/** 授权状态 */
export const checkStatusCol = useTableColumn({
  label: '授权状态',
  prop: 'checkStatus',
  formatter: ({ cellValue }) => CHECK_STATUS[cellValue]?.label || '-',
  render({ row, cellValue }) {
    return (
      <>
        <div>
          <span style="margin-right: 5px;">
            {CHECK_STATUS[cellValue]?.label || '-'}
          </span>
          {+row.employStatus === 1 && (
            <div style="display: flex; align-items: center;">
              <BaseIcon>
                <WarnTriangleFilled color="red" />
              </BaseIcon>
              存在报税关系
            </div>
          )}
        </div>
      </>
    );
  }
});

/** 人员类型 */
export const userTypeCol = useTableColumn({
  label: '人员类型',
  prop: 'userType',
  formatter: ({ cellValue, row }) =>
    `${USER_TYPE[cellValue]?.label || '-'}${
      row.upIndividual === 1 ? '（升级中）' : ''
    }`
});

/** 合同状态 */
export const contractStatusCol = useTableColumn({
  label: '服务商签约状态',
  prop: 'aspSignStatus',
  formatter: ({ cellValue }) => HETONG_STATUS[cellValue]?.label || '-'
});

/** 支付通道 */
export const payPassagewayNameCol = useTableColumn({
  label: '支付通道',
  prop: 'openStatus',
  formatter: ({ cellValue }) => OPEN_STATUS?.[cellValue]?.label || '-'
});

/** 平台审核状态 */
export const platformAuditStatusCol = useTableColumn({
  label: '平台审核状态',
  prop: 'platformAuditStatus',
  render({ row, cellValue }) {
    return (
      <>
        <div style="display: flex; align-items: center;">
          <span style="margin-right: 5px;">
            {PLATFORM_AUDIT_STATUS[cellValue]?.label || '-'}
          </span>
          {(row.platformAuditReason || row.auditOpinion) && cellValue === 3 ? (
            <BaseToolTip
              effect="dark"
              content={row.platformAuditReason || row.auditOpinion}
              placement="top-start"
            >
              <BaseIcon size="15" color="red">
                <WarningFilled />
              </BaseIcon>
            </BaseToolTip>
          ) : (
            ''
          )}
        </div>
      </>
    );
  }
});

/** 服务商审核状态 */
export const auditStatusCol = useTableColumn({
  label: '服务商审核状态',
  prop: 'auditStatus',
  render({ row, cellValue }) {
    return (
      <>
        <div style="display: flex; align-items: center;">
          <span style="margin-right: 5px;">
            {AUDIT_STATUS[cellValue]?.label || '-'}
          </span>
          {row.auditReason && cellValue === 3 ? (
            <BaseToolTip
              effect="dark"
              content={row.auditReason}
              placement="top-start"
            >
              <BaseIcon size="15" color="red">
                <WarningFilled />
              </BaseIcon>
            </BaseToolTip>
          ) : (
            ''
          )}
        </div>
      </>
    );
  }
});

/** 入驻状态 */
export const inStatusCol = useTableColumn({
  label: '入驻状态',
  prop: 'status',
  formatter({ cellValue, row }) {
    if (+row.cancelStatus === 1) {
      return '已退出';
    }
    return IN_STATUS[cellValue]?.label;
  }
});

/** 项目执行状态 */
export const projectStatusCol = useTableColumn({
  label: '项目执行状态',
  prop: 'projectStatus',
  formatter({ cellValue }) {
    return PROJECT_STATUS[cellValue]?.label || '-';
  }
});

/** 是否可结算 */
export const isSettlementCol = useTableColumn({
  label: '是否可结算',
  prop: 'isSettlement',
  formatter({ cellValue }) {
    return cellValue === 1 ? '是' : '否';
  },
  renderHeader() {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start'
        }}
      >
        <span style="margin-right: 5px;">是否可结算</span>
        <BaseIcon
          onClick={() => {
            createDialog({
              width: 300,
              title: '不可结算',
              showClose: true,
              contentRender: () => {
                return (
                  <div style="padding: 20px;">
                    <h3>1、基础要件缺失</h3>
                    <p>有效合同未签署或已过期</p>
                    <p>账户处于注销/冻结状态</p>
                    <h3>2、资质审核异常</h3>
                    <p>系统审核未通过（资料不全/信息不符）</p>
                    <p>本月可用结算额度已耗尽</p>
                    <h3>3、税务授权问题</h3>
                    <p>个人所得税代扣授权未完成</p>
                    <p>存在未解除的关联报税关系</p>
                  </div>
                );
              },
              beforeConfirm: async done => {
                done();
              }
            });
          }}
          style="cursor: pointer"
        >
          <InfoFilled></InfoFilled>
        </BaseIcon>
      </div>
    );
  }
});

/** 是否过期 */
export const isOverdueCol = useTableColumn({
  label: '是否过期',
  prop: 'isOverdue',
  formatter: ({ cellValue }) => IS_OVERDUE[cellValue]?.label || '-'
});

/** 人员状态 */
export const cancelStatusCol = useTableColumn({
  label: '人员状态',
  prop: 'cancelStatus',
  formatter: ({ cellValue }) => CANCEL_STATUS[cellValue]?.label || '-'
});

/** 预采购时间  */
export const prePurchaseAtCol = useTableColumn({
  label: '预采购时间 ',
  prop: 'taskDt',
  formatter: ({ cellValue }) => {
    return formatter.date(cellValue);
  }
});

/**
 * 剩余预采购任务量
 */
export const prePurchaseNumCol = useTableColumn({
  label: '剩余预采购任务量',
  prop: 'prePurchaseNum'
});

/** 工业接收任务量 */
export const industryNumCol = useTableColumn({
  label: '工业接收任务量',
  prop: 'industryNum'
});

/** 待审核任务量  */
export const toBeAuditTaskSumCol = useTableColumn({
  label: '待审核任务量 ',
  prop: 'passingNum'
});

/** 审核中任务量  */
export const passingNumCol = useTableColumn({
  label: '审核中任务量 ',
  prop: 'passingTaskSumPlatform'
});

/** 审核通过任务量  */
export const passNumCol = useTableColumn({
  label: '审核通过任务量 ',
  prop: 'passedTaskSumPlatform'
});

/** 审核未通过任务量  */
export const noPassNumCol = useTableColumn({
  label: '审核未通过任务量 ',
  prop: 'noPassNum'
});

/** 未完成任务量  */
export const noFinishNumCol = useTableColumn({
  label: '未完成任务量 ',
  prop: 'noFinishNum'
});

/** 预采购任务量完成进度  */
export const taskProgressCol = useTableColumn({
  label: '预采购任务量完成进度',
  prop: 'taskProgress',
  formatter: ({ cellValue }) => cellValue + '%'
});

/**剩余预采购金额（元/含税） */
export const taskSumNoFinishPriceCol = useTableColumn({
  label: '剩余预采购金额（元/含税）',
  prop: 'taskSumNoFinishPrice',
  minWidth: 230,
  formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
});

/**项目结算金额（元/含税） */
export const taskSumPassedCsoPriceCol = useTableColumn({
  label: '项目结算金额（元/含税）',
  prop: 'taskSumPassedCsoPrice',
  minWidth: 230,
  formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
});

/**当月剩余支付限额 */
export const monthSettlementPriceCol = useTableColumn({
  label: '当月剩余支付限额（元）',
  prop: 'currentMonthSurplusPayLimit',
  formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
});
/**服务承揽金额 */
export const servicePriceCol = useTableColumn({
  label: '服务承揽金额（元）',
  prop: 'servicePrice',
  minWidth: 230,
  formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
});

/**终端结算金额 */
export const appSettlementPriceCol = useTableColumn({
  label: '终端结算金额（元）',
  prop: 'appSettlementPrice',
  minWidth: 230,
  formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
});

/** 过期任务量 失效任务量 */
export const invalidTaskNumCol = useTableColumn({
  label: '过期任务量',
  prop: 'invalidTaskNum'
});

/** 审核进度 */
export const reviewProgressCol = useTableColumn({
  label: '审核进度',
  render: ({ row }) => {
    return (
      <div
        style={{ color: +row.passTaskSum > +row.residueTaskSum ? 'red' : '' }}
      >
        {`${row.passTaskSum}/${row.residueTaskSum}`}
      </div>
    );
  }
});

/** 结算状态 */
export const dataStateCol = useTableColumn({
  label: '结算状态',
  prop: 'dataState',
  formatter: ({ cellValue }) => SETTLEMENT_STATUS[cellValue]?.label || '-'
});

/** 提交状态 */
export const submitStatusCol = useTableColumn({
  label: '提交状态',
  prop: 'auditStatus',
  formatter: ({ cellValue }) => (cellValue === 2 ? '已提交' : '未提交')
});

/** 任务单价 */
export const priceCol = (
  xrkTableRef: Ref<XrkTableRef>,
  isAsp: boolean,
  isEntry: string
) => {
  // 协定服务类型
  // '1,3': '活动形式-双方共同上传',
  // '1,1': '活动形式-服务商上传',
  // '2,2': '人为维度-终端上传',
  // '2,1': '人为维度-服务商上传',
  return useTableColumn({
    label: '任务单价',
    prop: 'price',
    showOverflowTooltip: false,
    render: ({ cellValue, row }) => {
      let disabled = null;
      const shwoEdit = ['2,2', '2,1'].includes(isEntry); //非活动形式展示编辑按钮
      if (['1,1', '2,1', '2,2'].includes(isEntry)) {
        // 以人为度的:服务商上传和终端上传+以活动形式的服务商上传
        disabled = row.auditStatus === 2 && row.platformAuditStatus !== 3;
      } else {
        //双方共同上传
        disabled = row.auditStatus === 2;
      }
      if (row.isOverdue === 1 || row.superviseStatus !== 1) {
        disabled = true;
      }
      return (
        <>
          <div style="display: flex;align-items: center;justify-content: flex-start;">
            <span>
              {cellValue ? formatter.fen2yuan(cellValue, '元') : '未编辑'}
            </span>
            {isAsp && shwoEdit && (
              <BaseButton
                style="margin-left: 5px;"
                disabled={disabled}
                type="text"
                onClick={() => {
                  const baseInsertRef = ref();
                  const store = useProjectDetailStore();

                  createDialog({
                    width: 400,
                    title: '编辑金额',
                    showClose: true,
                    contentRender: () => {
                      return (
                        <>
                          <div style="padding:20px">
                            <BaseInsert
                              labelPosition={'left'}
                              ruleValidator={(
                                rule: any,
                                value: any,
                                callback: any
                              ) => {
                                if (+value === 0) {
                                  return callback(
                                    new Error('请输入 1~999999 之间金额')
                                  );
                                } else if (+value > 999999 || +value < 1) {
                                  return callback(
                                    new Error('请输入 1~999999 之间金额')
                                  );
                                } else {
                                  callback();
                                }
                              }}
                              label={'金额'}
                              placeholder={'请输入金额'}
                              maxlength={50}
                              type="number"
                              ref={baseInsertRef}
                              inputTextReplace={true}
                              defaultValue={cellValue / 100}
                            ></BaseInsert>
                          </div>
                        </>
                      );
                    },
                    beforeConfirm: async done => {
                      const { data } = await baseInsertRef.value.getFormData();
                      await updatePrice({
                        projectId: store.baseData.projectInfo.id,
                        taskRecordId: row.id,
                        amount: translator.yuan2fen(+data)
                      });
                      xrkTableRef.value.initCurrentList();
                      done();
                    }
                  });
                }}
              >
                编辑
              </BaseButton>
            )}
          </div>
        </>
      );
    }
  });
};

/** 点击数UV */
export const totalUvCol = useTableColumn({
  label: '点击数（UV）',
  prop: 'totalUv'
});

/** 终端结算单价 */
export const settlementPriceCol = useTableColumn({
  label: '终端结算单价（元）',
  prop: 'price',
  formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
});

/** 过期任务量 */
export const overdueCountCol = useTableColumn({
  label: '过期任务量',
  prop: 'overdueCount'
});

/** 已结算任务量 */
export const settlementCountCol = useTableColumn({
  label: '已结算任务量',
  prop: 'settlementCount'
});

/** 关联活动 */
export const activityNameCol = useTableColumn({
  label: '关联活动',
  prop: 'activityName',
  render({ cellValue }) {
    return (
      <>
        <BaseButton
          type="text"
          onClick={() => {
            router.replace({
              path: '/main/asp/task-mgmt-list/list',
              query: {
                activityName: cellValue,
                pageName: 'activity'
              }
            });
          }}
        >
          {cellValue}
        </BaseButton>
      </>
    );
  }
});

export const columnsByProjectType = (
  projectType: ProjectType,
  isEntry,
  xrkTableRef: Ref<XrkTableRef>,
  platForm,
  isGeti,
  isSetTime
) => {
  /**
   * 是否是工业
   */
  // const isIndustry = platForm === 1;
  /**
   * 是否是服务商
   */
  const isAsp = platForm === 2;
  /**
   * 是否是供应商
   */
  // const isSupplier = platForm === 3;

  const columnsItem = {
    6: [
      { ...servicePersonCol, label: isGeti ? '经营者' : '终端服务人员' },
      isGeti && individualNameCol,
      isGeti && parkNameCol,
      phoneCol,
      userTagCol,
      totalUvCol,
      settlementPriceCol,
      settlementCountCol,
      overdueCountCol
    ],
    21: [
      { ...servicePersonCol, label: isGeti ? '经营者' : '终端服务人员' },
      isGeti && individualNameCol,
      isGeti && parkNameCol,
      phoneCol,
      userTagCol,
      submitDtCol,
      taskCodeCol,
      auditStatusCol,
      auditUserCol,
      platformAuditStatusCol,
      isOverdueCol,
      reviewProgressCol,
      dataStateCol
    ],
    17: [
      { ...servicePersonCol, label: isGeti ? '经营者' : '终端服务人员' },
      isGeti && individualNameCol,
      isGeti && parkNameCol,
      phoneCol,
      userTagCol,
      submitDtCol,
      visitDtByDigitCol,
      taskCodeCol,
      auditStatusCol,
      auditUserCol,
      platformAuditStatusCol,
      isOverdueCol,
      reviewProgressCol,
      dataStateCol
    ],
    5: [
      { ...servicePersonCol, label: isGeti ? '经营者' : '终端服务人员' },
      isGeti && individualNameCol,
      isGeti && parkNameCol,
      phoneCol,
      userTagCol,
      submitDtCol,
      taskCodeCol,
      auditStatusCol,
      auditUserCol,
      platformAuditStatusCol,
      isOverdueCol,
      reviewProgressCol,
      dataStateCol
    ],
    20: [
      { ...servicePersonCol, label: isGeti ? '经营者' : '终端服务人员' },
      isGeti && individualNameCol,
      isGeti && parkNameCol,
      phoneCol,
      userTagCol,
      submitDtCol,
      isSetTime && visitDtCol,
      taskCodeCol,
      auditStatusCol,
      auditUserCol,
      platformAuditStatusCol,
      isOverdueCol,
      reviewProgressCol,
      dataStateCol
    ],
    19: {
      '2,2': [
        { ...servicePersonCol, label: isGeti ? '经营者' : '终端服务人员' },
        isGeti && individualNameCol,
        isGeti && parkNameCol,
        phoneCol,
        userTagCol,
        submitDtCol,
        taskCodeCol,
        priceCol(xrkTableRef, isAsp, '2,2'),
        auditStatusCol,
        auditUserCol,
        platformAuditStatusCol,
        isOverdueCol,
        dataStateCol
      ],
      '1,3': [
        { ...servicePersonCol, label: isGeti ? '经营者' : '终端服务人员' },
        isGeti && individualNameCol,
        isGeti && parkNameCol,
        phoneCol,
        userTagCol,
        submitDtCol,
        taskCodeCol,
        activityNameCol,
        priceCol(xrkTableRef, isAsp, '1,3'),
        auditStatusCol,
        auditUserCol,
        platformAuditStatusCol,
        isOverdueCol,
        dataStateCol
      ],
      '1,1': [
        { ...servicePersonCol, label: isGeti ? '经营者' : '终端服务人员' },
        isGeti && individualNameCol,
        isGeti && parkNameCol,
        phoneCol,
        userTagCol,
        submitDtCol,
        taskCodeCol,
        activityNameCol,
        priceCol(xrkTableRef, isAsp, '1,1'),
        platformAuditStatusCol,
        isOverdueCol,
        dataStateCol,
        submitStatusCol
      ],
      '2,1': [
        { ...servicePersonCol, label: isGeti ? '经营者' : '终端服务人员' },
        isGeti && individualNameCol,
        isGeti && parkNameCol,
        phoneCol,
        userTagCol,
        submitDtCol,
        taskCodeCol,
        useTableColumn({
          label: '任务附件',
          prop: 'fileStatus',
          render: ({ cellValue, row }) => {
            let disabled = null;
            if (['1,1', '2,1', '2,2'].includes(isEntry)) {
              // 以人为度的:服务商上传和终端上传+以活动形式的服务商上传
              disabled = row.auditStatus === 2 && row.platformAuditStatus !== 3;
            } else {
              //双方共同上传
              disabled = row.auditStatus === 2;
            }
            if (row.isOverdue === 1 || row.superviseStatus !== 1) {
              disabled = true;
            }
            return (
              <>
                {cellValue ? '已上传' : '未上传'}
                {isAsp && (
                  <BaseButton
                    disabled={disabled}
                    onClick={() => {
                      const taskUploadFileModal = useCreateModal(
                        TaskUploadFile,
                        {
                          taskRecordId: row.id,
                          onSuccess() {
                            XrkMessage.success('操作成功');
                            taskUploadFileModal.remove();
                            xrkTableRef.value.initCurrentList();
                          }
                        }
                      );
                    }}
                    type="text"
                  >
                    编辑
                  </BaseButton>
                )}
              </>
            );
          }
        }),
        priceCol(xrkTableRef, isAsp, '2,1'),

        platformAuditStatusCol,
        isOverdueCol,
        dataStateCol,
        submitStatusCol
      ]
    }
  };
  // 协定服务类型
  // '1,3': '活动形式-双方共同上传',
  // '1,1': '活动形式-服务商上传',
  // '2,2': '人为维度-终端上传',
  // '2,1': '人为维度-服务商上传',
  let columns: any[] = [];

  const target = columnsItem[projectType];

  if (Array.isArray(target)) {
    columns = target;
  } else if (typeof target === 'object' && target !== null) {
    columns = target[isEntry as keyof typeof target] || [];
  }

  return columns.filter(Boolean).filter(col => {
    if (IS_ASSISTANT) {
      return (
        col.prop !== 'platformAuditStatus' &&
        col.prop !== 'isOverdue' &&
        col.prop !== 'dataState'
      );
    }
    return true;
  });
};

/** 项目结算单价（不含税） */
export const projectPriceCol = useTableColumn({
  label: '项目结算单价（不含税）',
  prop: 'price',
  formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
});

/** 终端结算单价 */
export const cPriceCol = useTableColumn({
  label: '终端结算单价',
  prop: 'terminalPrice',
  formatter: ({ cellValue }) => formatter.fen2yuan(cellValue)
});
